export function formatDate(date) {
    date = new Date(date)
    return (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear()
}

export function formatDateTime(date) {
    date = new Date(date)
    function zero(a) {
        if (a < 10) {
            return '0' + a
        }
        return a
    }
    return (date.getMonth()+1) + "/" + date.getDate() + "/" + date.getFullYear() + ' ' + zero(date.getHours()) + ':' + zero(date.getMinutes()) + ':' + zero(date.getSeconds())
}

export function formatDateTimeUTC(date) {
    date = new Date(date)
    function zero(a) {
        if (a < 10) {
            return '0' + a
        }
        return a
    }
    return (
        (date.getUTCMonth()+1) + "/" +
        date.getUTCDate() + "/" +
        date.getUTCFullYear() + ' ' +
        zero(date.getUTCHours()) + ':' +
        zero(date.getUTCMinutes()) + ':' +
        zero(date.getUTCSeconds())
    )
}